import { createTheme, Shadows } from '@mui/material/styles';

const lightThemeCustom = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: 'rgb(190,209,113)'
    },
    secondary: {
      main: '#8ec222'
    },
    background: {
      paper: '#efefef'
    },
    info: {
      main: '#0288d1'
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          textTransform: 'none',
          padding: '8px 16px',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none'
          }
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          margin: '6px',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none'
          }
        }
      }
    }
  },
  shadows: Array(25).fill('none') as Shadows
});

// Export the theme with CSS variables
const lightThemeWithCssVars = {
  ...lightThemeCustom,
  cssVars: {
    '--color-primary': lightThemeCustom.palette.primary.main,
    '--color-secondary': lightThemeCustom.palette.secondary.main,
    '--color-background': lightThemeCustom.palette.background.default,
    '--color-paper': lightThemeCustom.palette.background.paper,
    '--color-text-primary': lightThemeCustom.palette.text.primary,
    '--color-text-secondary': lightThemeCustom.palette.text.secondary,
    '--color-button': lightThemeCustom.palette.primary.main,
    '--color-modal-background': '#EFEFEF'
  }
};

export default lightThemeWithCssVars;
